module.exports = __webpack_public_path__ + "img/CM-AE-25-Honda-Established.6e0b165f.jpg";